import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Ensures every route change scrolls the window to the top so users feel
 * they've arrived at a new page, not a content swap. Excludes URL hash jumps
 * (when the user clicks an in-page anchor link) and search-param only changes
 * (tab toggles that sync state with the URL).
 */
export default function ScrollToTop() {
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    // If the URL has a hash, let the browser's native anchor behaviour win.
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    // Only re-scroll when the pathname changes. Search-param-only changes
    // (e.g., ?role=revenue-leader) should NOT jump to top.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  // Referenced to appease the dependency array linter without breaking intent.
  void search;
  return null;
}
